import { custom, labeled, numberRequired } from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  custom(Joi)
    .object()
    .keys({
      purchaseProperty: Joi.boolean(),
      construction: Joi.boolean(),
      renovations: Joi.boolean(),
      investmentPurposes: Joi.boolean(),
      purchaseAsset: Joi.boolean(),
      refinance: Joi.boolean(),
      debtConsolidation: Joi.boolean(),
      other: Joi.boolean()
    })
    .orValue(
      'purchaseProperty',
      'construction',
      'renovations',
      'investmentPurposes',
      'purchaseAsset',
      'refinance',
      'debtConsolidation',
      'other'
    )
    .label(labeled(label, 'Purpose'))
    .when('.purchaseProperty', {
      is: true,
      then: Joi.object().keys({
        purchasePropertyAmount: numberRequired(Joi, 1).label(
          labeled(label, 'Purchase Property Amount')
        )
      })
    })
    .when('.construction', {
      is: true,
      then: Joi.object().keys({
        constructionAmount: numberRequired(Joi, 1).label(labeled(label, 'Construction Amount'))
      })
    })
    .when('.renovations', {
      is: true,
      then: Joi.object().keys({
        renovationsAmount: numberRequired(Joi, 1).label(labeled(label, 'Renovations Amount'))
      })
    })
    .when('.investmentPurposes', {
      is: true,
      then: Joi.object().keys({
        investmentPurposesAmount: numberRequired(Joi, 1).label(
          labeled(label, 'Investment Purposes Amount')
        )
      })
    })
    .when('.purchaseAsset', {
      is: true,
      then: Joi.object().keys({
        purchaseAssetAmount: numberRequired(Joi, 1).label(
          labeled(label, 'Purchase Asset Amount')
        )
      })
    })
    .when('.refinance', {
      is: true,
      then: Joi.object().keys({
        refinanceAmount: numberRequired(Joi, 1).label(labeled(label, 'Refinance Amount'))
      })
    })
    .when('.debtConsolidation', {
      is: true,
      then: Joi.object().keys({
        debtConsolidationAmount: numberRequired(Joi, 1).label(
          labeled(label, 'Debt Consolidation Amount')
        )
      })
    })
    .when('.other', {
      is: true,
      then: Joi.object().keys({
        otherAmount: numberRequired(Joi, 1).label(labeled(label, 'Other Amount'))
      })
    })

    .label(labeled(label, 'Purpose'));

export default {
  schema
};
